import React, { useState, useRef, useEffect } from "react";
import styles from "css_modules/Select.module.css";

export const NavSelect = ({
  data = [],
  value,
  onChange,
  direction = "down",
  inputClass = "",
  border,
  nav,
  tableSettings,
  tableSettingsTop
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const containerRef = useRef(null);

  const selectedItem = data.find(o => o.id === value);
  const listboxId = "navselect-listbox";

  const handleSelect = (item) => {
    setIsOpen(false);
    setHighlightedIndex(-1);
    onChange?.({
      target: { value: item.id }
    });
  };

  const handleKeyDown = (e) => {
    if (!isOpen) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        setIsOpen(true);
        setHighlightedIndex(0);
      }
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex(i => (i + 1) % data.length);
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex(i => (i - 1 + data.length) % data.length);
    }

    if (e.key === "Enter" && highlightedIndex >= 0) {
      e.preventDefault();
      handleSelect(data[highlightedIndex]);
    }

    if (e.key === "Escape") {
      e.preventDefault();
      setIsOpen(false);
    }
  };

  useEffect(() => {
    const onClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
        setHighlightedIndex(-1);
      }
    };

    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div
      ref={containerRef}
      className={`
        ${nav 
          ? styles.selectContainerNav 
          : tableSettingsTop
            ? styles.selectContainerTableSettingsTop 
            : tableSettings 
              ? styles.selectContainerTableSettings 
              : styles.selectContainer
        } 
        ${border ? styles.withBorder : ""} 
        ${inputClass}
      `}
      tabIndex={0}
      role="combobox"
      aria-expanded={isOpen}
      aria-controls={listboxId}
      aria-haspopup="listbox"
      aria-activedescendant={
        highlightedIndex >= 0
          ? `navselect-option-${highlightedIndex}`
          : undefined
      }
      onClick={() => setIsOpen(o => !o)}
      onKeyDown={handleKeyDown}
    >
      {/* Selected value */}
      <div className={styles.selectedValue}>
        {selectedItem ? (
          tableSettings && selectedItem.left ? (
            <div className={styles.optionRow}>
              <span className={styles.left}>{selectedItem.left}</span>
              <span className={styles.right}>{selectedItem.right}</span>
            </div>
          ) : (
            selectedItem.title
          )
        ) : (
          "----"
        )}
      </div>

      <span className={`${styles.arrow} ${isOpen ? styles.open : ""}`}>
        ▼
      </span>

      {/* Dropdown */}
      <div
        id={listboxId}
        role="listbox"
        className={`${styles.options} ${isOpen ? styles.open : ""} ${
          direction === "up" ? styles.dropup : ""
        }`}
      >
        {data.map((opt, idx) => (
          <div
            key={opt.id}
            id={`navselect-option-${idx}`}
            role="option"
            aria-selected={opt.id === value}
            className={`${styles.option}
              ${idx === highlightedIndex ? styles.highlighted : ""}
              ${opt.id === value ? styles.selected : ""}`}
            onClick={(e) => {
              e.stopPropagation(); // prevent toggle glitch
              handleSelect(opt);
            }}
            onMouseEnter={() => setHighlightedIndex(idx)}
          >
            {tableSettings && opt.left ? (
              <div className={styles.optionRow}>
                <span className={styles.left}>{opt.left}</span>
                <span className={styles.right}>{opt.right}</span>
              </div>
            ) : (
              opt.title
            )}
          </div>
        ))}
      </div>
    </div>
  );
};